import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { InvoicesView } from '../../../modules/invoices/invoices-view'

const invoicesSearchSchema = z.object({
  q: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
})

export const Route = createFileRoute('/_authed/invoices/')({
  validateSearch: invoicesSearchSchema,
  component: InvoicesRoute,
})

function InvoicesRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <InvoicesView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => {
            const next: Record<string, unknown> = { ...prev, ...patch }
            for (const [key, value] of Object.entries(next)) {
              if (value == null || value === '') delete next[key]
            }
            return next
          }) as never,
          replace: true,
        })
      }
    />
  )
}
